import { type FC, type PropsWithChildren, type ReactNode, useState } from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import styles from './AgentSessionPanel.module.scss';

interface AgentSessionPanelProps {
  id: string;
  title: string;
  icon: ReactNode;
}

/**
 * Collapsible overlay panel for the agent session canvas. Used for Configuration (left) and
 * Activity (right). Collapses to its header on toggle; children render inside the body when provided.
 */
const AgentSessionPanel: FC<PropsWithChildren<AgentSessionPanelProps>> = ({ id, title, icon, children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <aside className={styles.panel} data-test-component="AgentSessionPanel" data-testid={id}>
      <button
        type="button"
        className={styles.header}
        onClick={() => setCollapsed((c) => !c)}
        aria-expanded={!collapsed}
        aria-controls={id}
        data-test-element="header"
      >
        {icon}
        <span className={styles.headerLabel} data-test-element="title">
          {title}
        </span>
        <RiArrowDownSLine className={`${styles.chevron} ${collapsed ? styles.chevronOpen : ''}`} />
      </button>
      <div id={id} className={`${styles.body} ${collapsed ? styles.bodyCollapsed : ''}`} data-test-element="body">
        {children}
      </div>
    </aside>
  );
};

export default AgentSessionPanel;
